"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Article = _interopRequireDefault(require("./Article"));

var _Page = _interopRequireDefault(require("./Page"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const templates = {
  "device": _Page.default,
  "page": _Page.default,
  "article": _Article.default
};

const PreviewKiosk = props => {
  const documentType = props && props.formData && props.formData.documentType;
  let template;

  if (documentType && documentType.startsWith('page')) {
    template = "page";
  } else {
    template = documentType;
  }

  let PreviewTemplate = templates && templates[template];

  if (!PreviewTemplate) {
    return _react.default.createElement("p", null, "No preview for ", documentType);
  }

  return _react.default.createElement(PreviewTemplate, props);
};

var _default = PreviewKiosk;
exports.default = _default;
module.exports = exports.default;